// extracted by mini-css-extract-plugin
module.exports = {"two-stories-wrapper":"row2-m__two-stories-wrapper__2Nzzv","base":"row2-m__base__1Cals"};